import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getCheckout(type, date) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/checkout/detail/?type=${type}&date=${date}`;
    return httpGet(apiUrl);
  }

  getCheckoutByCheckoutDate(type, dateBegin, dateEnd) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/checkout/range/?type=${type}&dateBegin=${dateBegin}&dateEnd=${dateEnd}`;
    return httpGet(apiUrl);
  }

  updateCheckout(doc, optStaff) {
    let data = { doc, optStaff };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/checkout/`;
    return httpPut(apiUrl, data);
  }

  getLastHandover() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/checkout/handover/getLast`;
    return httpGet(apiUrl);
  }

  getPeriodIncome(startTime, endTime) {
    let data = { startTime, endTime };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/checkout/handover/getPeriod`;
    return httpPost(apiUrl, data);
  }
}
